import styled from "@emotion/styled";

import { touchOptimizedStyles } from "shared/components/common/base-link/styles";
import { ZIndexLayer } from "shared/lib/styles";

import { Popper } from "scmp-app/components/common/popper";

import IconShare from "./icon-share.svg";

export const StyledIconShare = styled(IconShare)`
  ${touchOptimizedStyles}
`;

export const StyledPopper = styled(Popper)`
  z-index: ${ZIndexLayer.Tooltip};
  ${touchOptimizedStyles}
`;

export const Container = styled.div`
  inline-size: 36px;
  block-size: 36px;

  ${StyledIconShare} {
    border-radius: 50%;

    cursor: pointer;

    :hover {
      background-color: #dddddd;
    }
  }
`;
